import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import "./Common.scss";
import App from "./App";
import ExploreCollections from "./Pages/ExploreCollections";
import reportWebVitals from "./reportWebVitals";
import EditProfile from "./Pages/EditProfile";
import EditProfileResult from "./Pages/EditProfileResult";
import NftDetails from "./Pages/NftDetails";
import CreateItem from "./Pages/CreateItem";
import SearchResult from "./Pages/SearchResult";
import CollectionDetails from "./Pages/CollectionDetails";
import UserProfile from "./Pages/UserProfile";
import StatsRankings from "./Pages/StatsRankings";
import StatsActivity from "./Pages/StatsActivity";
import Settings from "./Pages/Settings";
import SignUp from "./Pages/SignUp";
import NftList from "./Pages/NftList";
import NftCompleteList from "./Pages/NftCompleteList";
import CreateCollection from "./Pages/CreateCollection";
import Login from "./Pages/Login";
import CollectionList from "./Pages/CollectionList";
import ProtectedRoute from "./Components/ProtectedRoute";
import ExploreNfts from "./Pages/ExploreNfts";
import Category from "./Pages/Category";
import Error404 from "./Pages/Error404";
import EditCollection from "./Pages/EditCollection";
import EditItem from "./Pages/EditItem";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="ExploreCollections" element={<ExploreCollections />} />
        <Route path="ExploreNfts" element={<ExploreNfts />} />
        <Route path="NftDetails" element={<NftDetails />} />
        <Route path="SearchResult" element={<SearchResult />} />
        <Route path="CollectionDetails" element={<CollectionDetails />} />
        <Route path="StatsRankings" element={<StatsRankings />} />
        <Route path="StatsActivity" element={<StatsActivity />} />
        <Route path="SignUp" element={<SignUp />} />
        <Route path="NftCompleteList" element={<NftCompleteList />} />
        <Route path="UserProfile" element={<UserProfile />} />
        <Route path="Category" element={<Category />} />
        <Route element={<ProtectedRoute />}>
          <Route path="CreateItem" element={<CreateItem />} />
          <Route path="CreateCollection" element={<CreateCollection />} />
          <Route path="NftList" element={<NftList />} />
          <Route path="MyCollections" element={<CollectionList />} />
          <Route path="Settings" element={<Settings />} />
          <Route path="EditProfile" element={<EditProfileResult />} />
          <Route path="EditCollection" element={<EditCollection />} />
          <Route path="EditItem" element={<EditItem />} />
        </Route>
        <Route path="Login" element={<Login />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
